import * as modal from '../modal/modal';

interface Config {
  getProgressUrl?: string;
}

export class Form {
  static getProgressUrl?: string;

  jqForm: JQuery;
  actions: { fieldId: string; val: string }[];
  progress?: { title: string; message: string };
  resultUrl?: string;
  resultFunction?: (result: unknown | undefined, progressId: string) => void;
  errorFunction?: (error?: string, progressId?: string) => void;

  constructor(jqForm: JQuery) {
    this.jqForm = jqForm;
    this.actions = [];
  }

  withProgress(progressTitle: string, loadingMessage: string): Form {
    this.progress = { title: progressTitle, message: loadingMessage };
    return this;
  }

  withAction(actionFieldId: string, actionVal: string): Form {
    this.actions.push({ fieldId: actionFieldId, val: actionVal });
    return this;
  }

  toEndpoint(url: string): Form {
    this.jqForm.prop('action', url);
    return this;
  }

  onCompletion(resultUrl: string | undefined, resultFunction: (result: unknown, progressId: string) => void): Form {
    this.resultUrl = resultUrl;
    this.resultFunction = resultFunction;
    return this;
  }

  onError(errorFunction: (error?: string, progressId?: string) => void): Form {
    this.errorFunction = errorFunction;
    return this;
  }

  submit(): void {
    if (this.progress) {
      throw new Error('Synchronous submit() cannot be used with progress');
    }
    this.pushActions();
    this.jqForm.submit();
  }

  ajaxSubmit(): void {
    this.pushActions();
    modal.ShowProcessing();
    this.createProgress();
    this.jqForm.ajaxSubmit({
      success: (data) => {
        if (data.Success === false) {
          this.errorFunction?.(data.Message);
        } else {
          this.startProgress(data.Result as string);
        }
      },
      error: (request) => this.errorFunction?.(errorText(request.status)),
    });
  }

  private pushActions(): void {
    for (let i = 0; i < this.actions.length; i++) {
      const action = this.actions[i];
      $('#' + action.fieldId).val(action.val);
    }
  }

  private createProgress(): void {
    const progressTitleContainer = $('#progress-container #progressTitle');
    const loadingMessageContainer = $('#progress-container #progressMessage');

    if (progressTitleContainer.length > 0 && this.progress?.title) {
      progressTitleContainer.text(this.progress?.title);
    }

    if (loadingMessageContainer.length > 0 && this.progress?.message) {
      loadingMessageContainer.text(this.progress?.message);
    }
  }

  private startProgress(progressId: string): void {
    if (this.progress !== undefined && this.progress !== null) {
      createProgress(this.progress.message, Form.getProgressUrl, this.resultUrl, this.resultFunction, this.errorFunction, progressId);
    }
  }

  static config({ getProgressUrl }: Config): void {
    Form.getProgressUrl = getProgressUrl;
  }

  static fromSelector(selector: string): Form {
    return new Form($(selector));
  }

  static closestTo(selector: string): Form {
    return new Form($(selector).closest('form'));
  }

  static errorHandler(redirectUrl: string, defaultError: string): (error?: string, progressId?: string) => void {
    return (error?: string, progressId?: string) => {
      let messageString = `&errorMessage=${error || defaultError || UiText.t('Shared_UnknownErrorOccured_Error')}`;
      if (progressId) {
        messageString += `&progressId=${progressId}`;
      }
      window.location.href = redirectUrl + messageString;
    };
  }
}

function errorText(status: number) {
  switch (status) {
    case 401:
    case 403:
      return UiText.t('Error_RouteAccessDenied_Text');
    case 413:
      return UiText.t('DocumentUpload_FileTooBigGeneric_Error');
    default:
      return undefined;
  }
}

function createProgress(
  loadingMessage: string,
  getProgressUrl: string | undefined,
  resultUrl: string | undefined,
  resultFunction: ((result: unknown | undefined, progressId: string) => void) | undefined,
  onError: ((error?: string, progressId?: string) => void) | undefined,
  progressId: string,
) {
  if (!getProgressUrl) {
    throw new Error(`Missing 'getProgressUrl'`);
  }
  const loadingMessageContainer = $('#progress-container #progressMessage');
  window.sh.progress.Progress.create(
    progressId,

    loadingMessageContainer.get(0)!,
    getProgressUrl,
    loadingMessage,
    resultUrl,
    (result, error) => {
      if (error) {
        onError?.(error, progressId);
      } else {
        resultFunction?.(result, progressId);
      }
    },
  ).run();
}
